export default __webpack_public_path__ + "static/media/Logo_fig.892296e0.png";